document.addEventListener('DOMContentLoaded', function() {
    const productGalleryElement = document.querySelector('.landing-product-gallery__media.swiper');
    
    if (productGalleryElement && typeof Swiper != 'undefined') {
        new Swiper(productGalleryElement, {
            slidesPerView: 2.2,
            slidesPerGroup: 1,
            spaceBetween: 10,
            navigation: {
                nextEl: ".gallery-media__button--next",
                prevEl: ".gallery-media__button--prev",
            },
            breakpoints: {
                768: {
                    slidesPerView: 3.3,
                    slidesPerGroup: 1,
                    spaceBetween: 18,
                }
            }
        })
    }
})